module.exports = __webpack_public_path__ + "img/critics-logo.325c133c.svg";